import { render, staticRenderFns } from "./sidebarL2.vue?vue&type=template&id=45f80e7a&scoped=true"
import script from "./sidebarL2.vue?vue&type=script&lang=js"
export * from "./sidebarL2.vue?vue&type=script&lang=js"
import style0 from "./sidebarL2.vue?vue&type=style&index=0&id=45f80e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f80e7a",
  null
  
)

export default component.exports